import React from 'react';
import { fetchData } from '../../middleware/fetchData';
import { message } from 'antd';
import './index.less';
import {getIsWxClient} from '../../utils/commonUtils';
import noWxWarnIcon from '../../image/noWxWarnIcon.png';

// 重复入群白名单授权
class RepeatWhiteListAuthorization extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            noWxFlag: false
        };
    }

    componentWillMount() {
        if (!getIsWxClient()) {
            this.setState({noWxFlag: true});
            return;
        }
        const search = window.location.search;
        if (search.includes('code=')) {
            const searchArr = search.slice(1, search.length).split('&');
            const code = (searchArr.find(item => item.includes('code')) || '').replace('code=', '');
            let params = { code, companyId: sessionStorage.companyId };
            if (!!sessionStorage.linkAppId) {
                params.appId = sessionStorage.linkAppId;
            }
            // 重定向进来的 code给后端 返回unionid
            fetchData('/scrm-base/pass/queryUserInfoByCode', {
                body: JSON.stringify(params)
            }).then((userInfoRes) => {
                if (userInfoRes && userInfoRes.code === 200) {
                    fetchData('/scrm-wechat/pass/scanBinding', {
                        body: JSON.stringify({ unionid: userInfoRes.data.unionId , frontMatching: sessionStorage.frontMatching })
                    }).then((res) => {
                        if (res && res.code === 200) {
                            message.success('绑定成功，1秒后自动关闭该页面！');
                            setTimeout(() => {
                                document.addEventListener(
                                    'WeixinJSBridgeReady',
                                    function() {
                                        window.WeixinJSBridge.call('closeWindow');
                                    },
                                    false
                                );
                                window.WeixinJSBridge.call('closeWindow');
                            }, 1000);
                        }
                    });
                }
            });
        } else {
            // 刚跳进来后获取URL上携带参数 companyId 公司id frontMatching 前端随机数
            const searchArr = search.slice(1, search.length).split('&');
            const companyId = (searchArr.find(item => item.includes('companyId')) || '').replace('companyId=', '');
            const linkAppId = (searchArr.find(item => item.includes('appId')) || '').replace('appId=', '');
            const frontMatching = (searchArr.find(item => item.includes('frontMatching')) || '').replace('frontMatching=', '');
            const scene = (searchArr.find(item => item.includes('scene')) || '').replace('scene=', '');
            const businessId = (searchArr.find(item => item.includes('businessId')) || '').replace('businessId=', '');
            // 存储url上的参数
            linkAppId && (sessionStorage.linkAppId = linkAppId);
            companyId && (sessionStorage.companyId = companyId);
            frontMatching && (sessionStorage.frontMatching = frontMatching);
            scene && (sessionStorage.scene = scene);
            businessId && (sessionStorage.businessId = businessId);
            fetchData('/scrm-base/pass/queryAppInfo', {
                body: JSON.stringify({ companyId, scene, businessId })
            }).then((res) => {
                if (res && res.code === 200) {
                    const { appId, platformAppId } = res.data;
                    const authAppId = linkAppId ? linkAppId : appId;
                    // 跳转微信授权
                    const params = {
                        companyId,
                        scene,
                        businessId,
                        courseUrl: window.location.href
                    };
                    fetchData('/scrm-base/pass/queryDomain', {
                        body: JSON.stringify(params)
                    }).then((res) => {
                        if (res && res.code === 200 && res.data) {
                            const { wechatAuthDomain, wechatType, wechatSeq } = res.data;
                            let wxplatform = `https://${wechatAuthDomain}/pro5/index.html`;
                            let backendUrl = `&response_type=code&scope=snsapi_userinfo&state=STATE&component_appid=${platformAppId}#wechat_redirect`;
                            if (wechatType === 'SELF') {
                                backendUrl = `&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
                            }
                            const url = encodeURIComponent(`${wxplatform}?wechatSeq=${wechatSeq}&env=${process.env.Text}&companyId=${companyId}`);
                            console.log('redirect_uri=', url);
                            window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${authAppId}&redirect_uri=${url}${backendUrl}`)
                        } else {
                            message.error('获取授权域名失败');
                        }
                    });
                }
            });
            
        }
    }

    render() {
        return (
            <div className="repeat-white-list-authorization">
                {this.state.noWxFlag && <div className="no-data">
                    <img src={noWxWarnIcon} alt="" style={{height: 'auto'}}/>
                    请在微信客户端打开
                </div>}
            </div>
        );
    }
}

export { RepeatWhiteListAuthorization };